export default "__VITE_ASSET__Y_wpqkTO__"